module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": _vm.id,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "multiple": _vm.multiple
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0df1deec!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/v-components/plugins/select2.vue
// module id = 186
// module chunks = 0 1 2 3 4 5 6 7 8 10 12 15 16 17 18 19 20 21 23 24 25 26 27 28 30